import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Badge } from 'reactstrap';
import { getComplianceUpdates } from '../../../actions';
import { getDetailedUser } from '../../../actions/users';
import { GET_WORKER_DETAILS_SUCCESS } from '../../../actions/actionTypes';
import { checkrDashboardURI, appPath } from '../../../constants';
import BackArrow from '../../common/ui/BackArrow';

class Checkr extends Component {
  constructor (props) {
    super(props);
    this.state = { compliance_updates: [] };
  }

  componentDidMount () {
    const {
      getComplianceUpdates, getDetailedUser, match: { params: { id } }
    } = this.props;
    getDetailedUser(id, GET_WORKER_DETAILS_SUCCESS)
      .then(user => {
        if (user.compliance_candidate_id) {
          getComplianceUpdates(user.compliance_candidate_id)
            .then(compliance_updates => this.setState({ compliance_updates }));
        }
      });
  }

  render () {
    const { compliance_updates: cpu } = this.state;
    const { match: { params: { id } } } = this.props;

    return (
      <div className='col col-12'>
        <BackArrow
          history={this.props.history}
          location={this.props.location}
          defaultBackPath={`/${appPath}/workers/${id}`}
        />
        {cpu.length ? (
          <div className='list-group'>
            {cpu.map(update => {
              const { webhook_data: hook } = update;
              return (
                <div className='list-group-item' key={update.id}>
                  <div className='mt-2'>
                    <strong
                      className='text-capitalize'>{update.event_type.replace(/\./g, ' ')}</strong>
                  </div>
                  <hr />
                  <div className='mb-1 text-truncate'>Admin URI: <a
                    className='text-info'
                    href={checkrDashboardURI + hook.uri}
                    target='_blank'>{checkrDashboardURI + hook.uri}</a>
                  </div>
                  <div className='mb-1 text-truncate'>Invitation URL: <a
                    className='text-info'
                    href={hook.invitation_url}
                    target='_blank'>{hook.invitation_url}</a></div>
                  <div>Status: <Badge className='text-capitalize'
                    color='info'>{hook.status}</Badge></div>
                </div>
              );
            })}
          </div>
        ) : `No Checkr updates yet`}
      </div>
    );
  }
}

export default connect(null, { getComplianceUpdates, getDetailedUser })(Checkr);



// WEBPACK FOOTER //
// ./src/components/app/workerDetails/Checkr.js